import { Col } from '@design-system/components/grid/grid';
import { TextInput } from '../../../promotions/view/components/TextInput';
import { wrapper } from '../pdf/form.css';
import { NumberInput } from '@client/new/pages/promotions/view/components/NumberInput';
import { ExtrasFormHeader } from '../components/ExtrasFormHeader';
import { LegacyGuideViewModel } from './legacy-guide.viewModel';
import { ContentLegacyGuide } from '../model/extras.domain';

type LegacyGuideFormProps = {
  legacyGuideVM: LegacyGuideViewModel;
};

export const LegacyGuideForm = ({ legacyGuideVM }: LegacyGuideFormProps) => {
  const { register } = legacyGuideVM;

  const content: ContentLegacyGuide = {
    type: 'ContentLegacyGuide',
    value: legacyGuideVM.content,
  };

  return (
    <div>
      <Col data-testid="ContentLegacyGuideForm" gap="2xl" className={wrapper}>
        <ExtrasFormHeader content={content} />
        <NumberInput label="Content ID" {...register('contentId')} required />
        <NumberInput label="Number of slides" {...register('count')} required />
        <TextInput label="Guide name" {...register('title')} required />
      </Col>
    </div>
  );
};
